<template>
  <div>
    <v-dialog v-model="showModal" persistent max-width="600">
      <v-card justify="center" class="p-1">
        <v-card-title>Add Release Notes
          <v-spacer/>
          <v-btn icon @click="close">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-form @submit.prevent="save" ref="form" lazy-validation>
            <v-text-field
              v-model="newReleaseNotes.releaseId"
              :rules="[(v) => !!v || 'Release ID is required']"
              label="Release ID"
              outlined
              dense
              :error-messages="validationErrors.releaseId"
            />
            <v-menu
              ref="menu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="auto"
              v-model="openDatePicker"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  class="pt-0"
                  v-model="newReleaseNotes.releaseDate"
                  label="Release Date"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  :rules="[(v) => !!v || 'Release Date is required']"
                  outlined
                  dense
                  :error-messages="validationErrors.releaseDate"
                />
              </template>
              <v-date-picker
                class="white--text"
                no-title
                scrollable
                v-model="newReleaseNotes.releaseDate"
              >
                <v-spacer/>
                <v-btn
                  small
                  text
                  color="secondary"
                  @click="openDatePicker = false"
                >
                  Cancel
                </v-btn>
                <v-btn
                  small
                  text
                  color="secondary"
                  @click="openDatePicker = false"
                >
                  OK
                </v-btn>
              </v-date-picker>
            </v-menu>
            <v-textarea
              v-model="newReleaseNotes.releaseNotes"
              auto-grow
              label="Release Notes"
              rows="3"
              outlined
              dense
              :error-messages="validationErrors.releaseNotes"
              max-height="100"
            />
            <v-btn color="secondary" type="submit">Add</v-btn>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
    <LoadingModal loadingText="Saving..." :showModal="isSubmitting" />
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import api from '@/common/api';
import LoadingModal from '@/common/components/LoadingModal.vue';
import { ReleaseNotes, initReleaseNotes } from '@/common/components/support/support.types';
import parse422 from '@/common/util/parseResponse.util';
import { initValidationErrors } from '@/common/validation/validation.types';

export default Vue.extend({
  data() {
    return {
      openDatePicker: false,
      newReleaseNotes: initReleaseNotes() as ReleaseNotes,
      isSubmitting: false as boolean,
      showModal: false as boolean,
      validationErrors: initValidationErrors(),
    };
  },
  methods: {
    submitActions(isSubmitting: boolean) {
      this.isSubmitting = isSubmitting;
    },
    save() {
      if (!this.isValid()) {
        return;
      }
      this.submitActions(true);
      api
        .post('/release-notes', this.newReleaseNotes)
        .then(() => {
          this.close();
          this.newReleaseNotes = initReleaseNotes();
          this.$emit('created');
          (this.$refs.form as any).resetValidation();
        })
        .catch(this.handleSaveError);
    },
    show() {
      this.showModal = true;
    },
    close() {
      this.submitActions(false);
      this.showModal = false;
    },
    isValid(): boolean {
      return (this.$refs.form as any).validate();
    },
    handleSaveError({ response }: { response: any }) {
      this.submitActions(false);
      const msg = parse422(
        response,
        `There was a problem saving the Release Notes. (${response.status})`,
      );
      this.$toasted.error(msg);
      this.validationErrors = response.data.errors || {};
    },
  },
  components: {
    LoadingModal,
  },
});
</script>
